import React from 'react';
import { Container } from 'reactstrap';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import InstallationLocationList from './InstallationLocationList';

const InstallationLocations = () => {
    document.title = "Ubicación Para Instalación | OpenLink";

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Ubicación Para Instalación" pageTitle="Configuración" icon="icon-map-pin" />
                    <InstallationLocationList />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default InstallationLocations;
